/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Goal_QuestionInputs */

const en_us2_onboarding_goal_question = /** @type {(inputs: Onboarding_Goal_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is your main goal?`)
};

const pt_br2_onboarding_goal_question = /** @type {(inputs: Onboarding_Goal_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é o seu principal objetivo?`)
};

const es_419_onboarding_goal_question = /** @type {(inputs: Onboarding_Goal_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es tu objetivo principal?`)
};

const pt_pt2_onboarding_goal_question = /** @type {(inputs: Onboarding_Goal_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é o teu principal objetivo?`)
};

const fr_fr2_onboarding_goal_question = /** @type {(inputs: Onboarding_Goal_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel est ton objectif principal ?`)
};

const de_de2_onboarding_goal_question = /** @type {(inputs: Onboarding_Goal_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist dein Hauptziel?`)
};

const it_it2_onboarding_goal_question = /** @type {(inputs: Onboarding_Goal_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è il tuo obiettivo principale?`)
};

/**
* | output |
* | --- |
* | "What is your main goal?" |
*
* @param {Onboarding_Goal_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_goal_question = /** @type {((inputs?: Onboarding_Goal_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Goal_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_goal_question(inputs)
	if (locale === "es-419") return es_419_onboarding_goal_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_goal_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_goal_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_goal_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_goal_question(inputs)
	return en_us2_onboarding_goal_question(inputs)
});
export { onboarding_goal_question as "onboarding.goal.question" }